import { withUnmountTransition } from '../../../../misc/withUnmountTransition.hoc'
import { FormMessageTemplateModal } from './FormMessageTemplateModal.component'

const withUnmountHoc = withUnmountTransition(FormMessageTemplateModal)
export { withUnmountHoc as FormMessageTemplateModal }
